import * as React from "react"
import * as classNames from "./RhCtxJobAdHeaderSection.module.scss"
import Card from "../../../../common/blocks/card/Card"
import Icon from "../../../../common/blocks/icon/Icon"
import CtxHeroSection from "../../../../common/sections/ctx-hero-section/CtxHeroSection"
import { formatDate } from "../../../../../../utils/formatDate"
import ShareBlock from "../../../../common/blocks/shareBlock/ShareBlock"

const CtxJobAdHeaderSection = ({
  title,
  publishDate,
}) => {
  const url = typeof window !== "undefined" ? window.location.href : ""
  const image = {
    data: {
      attributes: {
        alternativeText: null,
        formats: {
          L: {
            ext: ".webp",
            url: "https://media.paritel.fr/paritel-www-dev/assets/L_shutterstock_1503919118_edad7dfb8c.webp",
            hash: "L_shutterstock_1503919118_edad7dfb8c",
            mime: "image/webp",
            name: "L_header home Recrutement.jpg",
            path: null,
            size: 8.5,
            width: 770,
            height: 194,
          },
          M: {
            ext: ".webp",
            url: "https://media.paritel.fr/paritel-www-dev/assets/M_shutterstock_1503919118_edad7dfb8c.webp",
            hash: "M_shutterstock_1503919118_edad7dfb8c",
            mime: "image/webp",
            name: "M_header home Recrutement.jpg",
            path: null,
            size: 6.05,
            width: 590,
            height: 149,
          },
          S: {
            ext: ".webp",
            url: "https://media.paritel.fr/paritel-www-dev/assets/S_shutterstock_1503919118_edad7dfb8c.webp",
            hash: "S_shutterstock_1503919118_edad7dfb8c",
            mime: "image/webp",
            name: "S_header home Recrutement.jpg",
            path: null,
            size: 3.65,
            width: 390,
            height: 98,
          },
          OG: {
            ext: ".png",
            url: "https://media.paritel.fr/paritel-www-dev/assets/OG_shutterstock_1503919118_edad7dfb8c.png",
            hash: "OG_shutterstock_1503919118_edad7dfb8c",
            mime: "image/png",
            name: "OG_header home Recrutement.jpg",
            path: null,
            size: 1316.85,
            width: 1200,
            height: 630,
          },
          XL: {
            ext: ".webp",
            url: "https://media.paritel.fr/paritel-www-dev/assets/XL_shutterstock_1503919118_edad7dfb8c.webp",
            hash: "XL_shutterstock_1503919118_edad7dfb8c",
            mime: "image/webp",
            name: "XL_header home Recrutement.jpg",
            path: null,
            size: 20.3,
            width: 1440,
            height: 363,
          },
          XXL: {
            ext: ".webp",
            url: "https://media.paritel.fr/paritel-www-dev/assets/XXL_shutterstock_1503919118_edad7dfb8c.webp",
            hash: "XXL_shutterstock_1503919118_edad7dfb8c",
            mime: "image/webp",
            name: "XXL_header home Recrutement.jpg",
            path: null,
            size: 28.51,
            width: 1920,
            height: 484,
          },
          thumbnail: {
            ext: ".jpg",
            url: "https://media.paritel.fr/paritel-www-dev/assets/thumbnail_shutterstock_1503919118_edad7dfb8c.jpg",
            hash: "thumbnail_shutterstock_1503919118_edad7dfb8c",
            mime: "image/jpeg",
            name: "thumbnail_header home Recrutement.jpg",
            path: null,
            size: 3.03,
            width: 245,
            height: 61,
          },
        },
        height: 363,
        mime: "image/jpeg",
        size: 379.8,
        url: "https://media.paritel.fr/paritel-www-dev/assets/shutterstock_1503919118_edad7dfb8c.jpg",
        width: 1440,
      },
    },
  }

  return (
    <CtxHeroSection
      classes={"mb-5"}
      imgSrc={image?.data?.attributes.url}
      imgAlt={image?.data?.attributes.alternativeText}
      image={image?.data?.attributes}
    >
      <div className={classNames.annonce_header}>
        <Card className="container card_bottom flex flex-direction-column justify-content-end align-items-center text-center pbl-6 pin-3 fade-in-bottom">
          <h1>{title}</h1>
          <div
            className={`flex flex-direction-row align-items-center ${classNames.annonce_metas}`}
          >
            <div className={classNames.annonce_meta}>
              <Icon
                icon="calendar"
                width="16"
                height="16"
                color="var(--gris)"
              />
              <span className="quartary-text-color">
                {formatDate(publishDate)}
              </span>{" "}
              |
            </div>
            <div className={classNames.annonce_meta}>
              <ShareBlock url={url} />
            </div>
          </div>
        </Card>
      </div>
    </CtxHeroSection>
  )
}

export const name = "CtxJobAdHeaderSection"

export const init = (componentData, pageContext) => {
  return (
    <CtxJobAdHeaderSection
      key={componentData.id}
      title={pageContext.itemData.attributes.title}
      imageUrl={pageContext.itemData.attributes.image.data?.attributes.url}
      imageAlt={
        pageContext.itemData.attributes.image.data?.attributes.alternativeText
      }
      publishDate={pageContext.itemData.attributes.creationDate}
    />
  )
}

export default CtxJobAdHeaderSection
